"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Post } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type {
  CreateProductRequest,
  ProductDetailResponse,
} from "@stocks/shared";

export const useCreateProduct = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: CreateProductRequest) =>
      Post<ProductDetailResponse, CreateProductRequest>("/v1/products", values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [orderKeys.products] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "제품 등록에 실패했습니다."),
  });
};
